const TimeTypeEnum = Object.freeze({
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
});

export default TimeTypeEnum;
